(function () {
  'use strict';

  const LOGICAL_WIDTH = 960;
  const LOGICAL_HEIGHT = 600;
  const TWO_PI = Math.PI * 2;

  const TIRE_TYPES = [
    { id: 'winter', label: 'Winter', short: 'WIN', color: '#7fc8ff', accent: '#dff5ff', badgeKey: 'badge.tire.winter' },
    { id: 'all-season', label: 'All Season', short: 'ALL', color: '#58c27d', accent: '#dff8e8', badgeKey: 'badge.tire.all-season' },
    { id: 'performance', label: 'Performance', short: 'PER', color: '#ff6262', accent: '#ffe5e5', badgeKey: 'badge.tire.performance' },
    { id: 'truck', label: 'Truck', short: 'TRK', color: '#f5a524', accent: '#fff0d8', badgeKey: 'badge.tire.truck' },
    { id: 'budget', label: 'Budget', short: 'BUD', color: '#a98cff', accent: '#eee9ff', badgeKey: 'badge.tire.budget' }
  ];

  const ORDER_BAYS = [
    { id: 'A', x: 255, y: 527, color: '#4f8cff', dropRadius: 50 },
    { id: 'B', x: 411, y: 527, color: '#ff9f1c', dropRadius: 50 },
    { id: 'C', x: 572, y: 527, color: '#2ec4b6', dropRadius: 50 },
    { id: 'D', x: 741, y: 527, color: '#e71d73', dropRadius: 50 }
  ];

  const WORLD_BALANCE = {
    floorTireLimit: 8,
    pickupRadiusBase: 26,
    perfectMatchPickupBonus: 14,
    tireSpawnMinDistanceFromPlayer: 150,
    tireSpawnMinDistanceFromBay: 105,
    tireSpawnMinSpacing: 54
  };

  const TIRE_SPAWN_ZONES = [
    { x: 105, y: 135, jitterX: 48, jitterY: 36 },
    { x: 250, y: 125, jitterX: 58, jitterY: 34 },
    { x: 735, y: 125, jitterX: 58, jitterY: 34 },
    { x: 860, y: 150, jitterX: 50, jitterY: 54 },
    { x: 100, y: 285, jitterX: 42, jitterY: 62 },
    { x: 850, y: 300, jitterX: 46, jitterY: 64 },
    { x: 112, y: 430, jitterX: 46, jitterY: 56 },
    { x: 835, y: 442, jitterX: 50, jitterY: 46 },
    { x: 285, y: 225, jitterX: 52, jitterY: 48 },
    { x: 675, y: 225, jitterX: 52, jitterY: 48 }
  ];

  const CHARACTER_PRESETS = [
    {
      name: 'Mandy Li',
      title: 'Route Captain',
      speed: 6,
      handling: 7,
      capacity: 3,
      focus: 8,
      luck: 7,
      activeSkill: 'Executive Dispatch',
      activeDescription: '8 seconds of +35% order value and instant completion of the lowest-value active order.',
      passiveSkill: 'Founder Priority',
      passiveDescription: 'The first upgrade always includes a premium option.',
      qteSpecialty: 'Command events resolve with a wider timing window.',
      cooldown: 24
    },
    {
      name: 'Jarvan Chen',
      title: 'Precision Picker',
      speed: 6,
      handling: 9,
      capacity: 2,
      focus: 8,
      luck: 6,
      activeSkill: 'Perfect Match',
      activeDescription: 'Correct tires glow and pull toward you for 6 seconds. One wrong pickup is forgiven.',
      passiveSkill: 'Clean Scan',
      passiveDescription: 'SKU and alert QTE windows last 0.6 seconds longer.',
      qteSpecialty: 'Wrong SKU Alert',
      cooldown: 20
    },
    {
      name: 'Arshdeep Singh',
      title: 'Dock Sprinter',
      speed: 10,
      handling: 6,
      capacity: 2,
      focus: 6,
      luck: 5,
      activeSkill: 'Warehouse Sprint',
      activeDescription: 'Dash at high speed for 4 seconds and ignore oil or collision slowdowns.',
      passiveSkill: 'Fast Turnaround',
      passiveDescription: 'Fast order streaks can add bonus seconds, up to 8 seconds per run.',
      qteSpecialty: 'Oil Spill',
      cooldown: 18
    },
    {
      name: 'Anmol Gulshi',
      title: 'Heavy Loader',
      speed: 5,
      handling: 5,
      capacity: 5,
      focus: 6,
      luck: 6,
      activeSkill: 'Power Load',
      activeDescription: 'Gain +2 capacity for 8 seconds and one collision shield.',
      passiveSkill: 'Strong Grip',
      passiveDescription: 'Heavy load QTE failure penalties are cut in half.',
      qteSpecialty: 'Pallet Overload',
      cooldown: 24
    },
    {
      name: 'Richard Li',
      title: 'Route Strategist',
      speed: 6,
      handling: 7,
      capacity: 3,
      focus: 9,
      luck: 5,
      activeSkill: 'Reroute',
      activeDescription: 'Refresh the lowest-value order and clear the nearest obstacle.',
      passiveSkill: 'Plan Ahead',
      passiveDescription: 'Active bay route hints are stronger and easier to read.',
      qteSpecialty: 'Forklift Jam',
      cooldown: 22
    },
    {
      name: 'Cedrick Sun',
      title: 'Flex Ranger',
      speed: 7,
      handling: 7,
      capacity: 3,
      focus: 7,
      luck: 7,
      activeSkill: 'Adapt',
      activeDescription: 'The next order gains the bonus your current build needs most.',
      passiveSkill: 'All-Rounder',
      passiveDescription: 'All base stat upgrades are 10% stronger.',
      qteSpecialty: 'Rush Order',
      cooldown: 21
    },
    {
      name: 'Sanat Khare',
      title: 'Steady Guardian',
      speed: 5,
      handling: 8,
      capacity: 4,
      focus: 7,
      luck: 5,
      activeSkill: 'Steady Mode',
      activeDescription: 'For 7 seconds, wrong deliveries do not break combo and collisions are softened.',
      passiveSkill: 'Endless Stamina',
      passiveDescription: 'Below 20 seconds remaining, movement speed increases by 12%.',
      qteSpecialty: 'Safety Check',
      cooldown: 23
    },
    {
      name: 'Jeff Thorup',
      title: 'Nitro Driver',
      speed: 9,
      handling: 7,
      capacity: 2,
      focus: 5,
      luck: 8,
      activeSkill: 'Postal Nitro',
      activeDescription: 'Move at extreme speed for 5 seconds. Route markers award extra points.',
      passiveSkill: 'Veteran Route',
      passiveDescription: 'Long-distance deliveries score higher.',
      qteSpecialty: 'Rush Order',
      cooldown: 19
    },
    {
      name: 'Dustin Corbierre',
      title: 'Jolly Titan',
      speed: 4,
      handling: 6,
      capacity: 6,
      focus: 6,
      luck: 6,
      activeSkill: 'Carry More',
      activeDescription: 'Gain +3 capacity for 10 seconds with a small speed tradeoff.',
      passiveSkill: 'Reliable Mentor',
      passiveDescription: 'When combo breaks, 40% of the combo bonus is preserved.',
      qteSpecialty: 'Tire Stack Collapse',
      cooldown: 25
    },
    {
      name: 'Dakota Du',
      title: 'Design Wizard',
      speed: 7,
      handling: 8,
      capacity: 2,
      focus: 8,
      luck: 8,
      activeSkill: 'Smart Layout',
      activeDescription: 'Rearrange nearby tires and bay routes to favor the closest order.',
      passiveSkill: 'Creative Spark',
      passiveDescription: 'Rare movement and route upgrades appear more often.',
      qteSpecialty: 'Smart Layout',
      cooldown: 22
    }
  ];

  const QTE_EVENTS = [
    {
      id: 'tire-stack-collapse',
      name: 'Tire Stack Collapse',
      icon: 'stack',
      type: 'rapid',
      action: 'TAP',
      desktopGlyph: 'SPACE',
      mobileGlyph: 'TAP',
      eventFrameKey: 'qte.tire-stack-collapse.warning',
      desktopInputFrameKey: 'input.space',
      mobileInputFrameKey: 'input.rapid',
      prompt: 'TAP FAST',
      mobilePrompt: 'TAP FAST',
      success: 'Route cleared. Combo secured.',
      failure: 'A tire wall blocks the lane.',
      simple: true
    },
    {
      id: 'van-trouble',
      name: 'Van Trouble',
      icon: 'wrench',
      type: 'hold',
      action: 'FIX',
      desktopGlyph: 'E HOLD',
      mobileGlyph: 'HOLD',
      eventFrameKey: 'qte.van-trouble.warning',
      desktopInputFrameKey: 'input.eHold',
      mobileInputFrameKey: 'input.hold',
      prompt: 'HOLD',
      mobilePrompt: 'HOLD',
      success: 'Van fixed. Bonus time added.',
      failure: 'The bay stalls and time is lost.',
      simple: true
    },
    {
      id: 'forklift-jam',
      name: 'Forklift Jam',
      icon: 'forklift',
      type: 'sequence',
      action: 'CLEAR',
      desktopGlyph: 'ARROWS',
      mobileGlyph: 'SWIPE',
      eventFrameKey: 'qte.forklift-jam.warning',
      desktopInputFrameKey: 'input.arrows',
      mobileInputFrameKey: 'input.swipe',
      prompt: 'ARROWS',
      mobilePrompt: 'SWIPE',
      success: 'Shortcut opened.',
      failure: 'The forklift blocks the aisle.',
      simple: false
    },
    {
      id: 'wrong-sku-alert',
      name: 'Wrong SKU Alert',
      icon: 'sku',
      type: 'choice',
      action: 'MATCH',
      desktopGlyph: 'PICK',
      mobileGlyph: 'PICK',
      eventFrameKey: 'qte.wrong-sku-alert.warning',
      desktopInputFrameKey: 'input.accept',
      mobileInputFrameKey: 'input.tap',
      prompt: 'MATCH',
      mobilePrompt: 'MATCH',
      success: 'SKU corrected.',
      failure: 'Current order bonus cleared.',
      simple: false
    },
    {
      id: 'oil-spill',
      name: 'Oil Spill',
      icon: 'oil',
      type: 'dodge',
      action: 'DODGE',
      desktopGlyph: '← ↑ →',
      mobileGlyph: 'SWIPE',
      eventFrameKey: 'qte.oil-spill.warning',
      desktopInputFrameKey: 'input.arrows',
      mobileInputFrameKey: 'input.swipe',
      prompt: 'DODGE',
      mobilePrompt: 'SWIPE',
      success: 'Clean dodge. Speed boost gained.',
      failure: 'Sliding out of control.',
      simple: true
    },
    {
      id: 'pallet-overload',
      name: 'Pallet Overload',
      icon: 'pallet',
      type: 'timed',
      action: 'SYNC',
      desktopGlyph: 'SPACE',
      mobileGlyph: 'TAP',
      eventFrameKey: 'qte.pallet-overload.warning',
      desktopInputFrameKey: 'input.space',
      mobileInputFrameKey: 'input.tap',
      prompt: 'SYNC',
      mobilePrompt: 'SYNC',
      success: 'Temporary capacity increased.',
      failure: 'One carried tire drops.',
      simple: false
    },
    {
      id: 'rush-order',
      name: 'Rush Order',
      icon: 'rush',
      type: 'rush',
      action: 'ACCEPT',
      desktopGlyph: 'YES',
      mobileGlyph: 'YES',
      eventFrameKey: 'qte.rush-order.warning',
      desktopInputFrameKey: 'input.accept',
      mobileInputFrameKey: 'input.accept',
      prompt: 'ACCEPT',
      mobilePrompt: 'ACCEPT',
      success: 'Rush order accepted.',
      failure: 'Rush order skipped.',
      simple: false
    },
    {
      id: 'safety-check',
      name: 'Safety Check',
      icon: 'safety',
      type: 'zone',
      action: 'HOLD',
      desktopGlyph: 'E HOLD',
      mobileGlyph: 'HOLD',
      eventFrameKey: 'qte.safety-check.warning',
      desktopInputFrameKey: 'input.eHold',
      mobileInputFrameKey: 'input.hold',
      prompt: 'HOLD',
      mobilePrompt: 'HOLD',
      success: 'Inspection passed. Nearby hazards cleared.',
      failure: 'Inspection warning. Brief slowdown.',
      simple: false
    }
  ];

  const ATLAS_V3 = {
    assetFile: 'tire-rush-atlas-v3.webp',
    width: 2048,
    height: 2048,
    frames: {}
  };

  function defineAtlasFrame(key, x, y, w, h) {
    ATLAS_V3.frames[key] = { x, y, w, h };
  }

  defineAtlasFrame('warehouseBase', 0, 0, 1024, 640);
  defineAtlasFrame('routeDash', 0, 660, 256, 32);
  defineAtlasFrame('routeGlow', 0, 700, 256, 64);
  defineAtlasFrame('shadow', 280, 660, 128, 64);
  defineAtlasFrame('warningFrame', 420, 660, 256, 160);
  defineAtlasFrame('scanLine', 700, 660, 256, 24);

  TIRE_TYPES.forEach((type, row) => {
    for (let frame = 0; frame < 4; frame += 1) {
      defineAtlasFrame(`tire.${type.id}.${frame}`, 1060 + frame * 112, row * 112, 96, 96);
    }
  });

  ['north', 'east', 'south', 'west'].forEach((direction, row) => {
    for (let frame = 0; frame < 3; frame += 1) {
      defineAtlasFrame(`player.${direction}.${frame}`, 1060 + frame * 88, 620 + row * 100, 80, 90);
    }
  });

  ORDER_BAYS.forEach((bay, column) => {
    ['base', 'active', 'complete'].forEach((state, row) => {
      defineAtlasFrame(`bay.${bay.id}.${state}`, 1480 + column * 132, 620 + row * 100, 116, 84);
    });
  });

  ['cone', 'pallet', 'tire-wall', 'forklift', 'oil', 'box'].forEach((type, index) => {
    defineAtlasFrame(`obstacle.${type}`, 1060 + index * 150, 1040, 128, 128);
  });

  QTE_EVENTS.forEach((event, index) => {
    ['normal', 'warning', 'resolved', 'failed'].forEach((state) => {
      defineAtlasFrame(`qte.${event.id}.${state}`, index * 128, 1200, 120, 120);
    });
  });

  ['star', 'spark', 'dust', 'speedLine', 'repair', 'burst', 'warning'].forEach((type, index) => {
    defineAtlasFrame(`particle.${type}`, index * 116, 1340, 108, 96);
  });

  TIRE_TYPES.forEach((type, index) => {
    defineAtlasFrame(type.badgeKey, index * 112, 1460, 96, 96);
  });

  [
    'orderFrame',
    'cart',
    'chevron',
    'dockMiniBase',
    'dockMiniActive',
    'targetHalo',
    'dropGhost',
    'noEntry',
    'check',
    'fail'
  ].forEach((type, index) => {
    defineAtlasFrame(`guide.${type}`, index * 112, 1576, 96, 96);
  });

  ['pick', 'route', 'event'].forEach((type, index) => {
    defineAtlasFrame(`tutorial.${type}`, index * 272, 1692, 256, 112);
  });

  ['space', 'eHold', 'arrows', 'tap', 'hold', 'swipe', 'rapid', 'accept', 'skip'].forEach((type, index) => {
    defineAtlasFrame(`input.${type}`, index * 112, 1828, 96, 96);
  });

  function hasAtlasFrame(key) {
    return !!ATLAS_V3.frames[key];
  }

  const UPGRADE_POOL = [
    {
      id: 'grip-tires',
      title: 'Grip Tires',
      rarity: 'common',
      iconKey: 'badge.tire.all-season',
      description: '+1 Handling. Oil and slide penalties are softer.',
      apply(game) {
        game.mods.handling += 1;
        game.effects.grip = true;
      }
    },
    {
      id: 'extra-rack',
      title: 'Extra Rack',
      rarity: 'common',
      iconKey: 'guide.cart',
      description: '+1 Capacity for the rest of the run.',
      apply(game) {
        game.mods.capacity += 1;
      }
    },
    {
      id: 'route-scanner',
      title: 'Route Scanner',
      rarity: 'rare',
      iconKey: 'guide.targetHalo',
      description: 'Bay route hints become stronger and score +8%.',
      apply(game) {
        game.effects.routeScanner = true;
        game.mods.scoreMultiplier += 0.08;
      }
    },
    {
      id: 'fast-picker',
      title: 'Fast Picker',
      rarity: 'common',
      iconKey: 'guide.dropGhost',
      description: 'Target tire pickup field gets wider.',
      apply(game) {
        game.mods.pickupRadius += 8;
      }
    },
    {
      id: 'combo-insurance',
      title: 'Combo Insurance',
      rarity: 'rare',
      iconKey: 'guide.check',
      description: 'Once this run, a broken combo is protected.',
      apply(game) {
        game.effects.comboInsurance += 1;
      }
    },
    {
      id: 'lucky-dispatch',
      title: 'Lucky Dispatch',
      rarity: 'rare',
      iconKey: 'particle.star',
      description: 'Bonus orders and positive events appear more often.',
      apply(game) {
        game.mods.luck += 2;
      }
    },
    {
      id: 'qte-reflex',
      title: 'QTE Reflex',
      rarity: 'common',
      iconKey: 'tutorial.event',
      description: 'Event windows gain +0.4 seconds.',
      apply(game) {
        game.mods.qteWindow += 0.4;
      }
    },
    {
      id: 'forklift-shortcut',
      title: 'Forklift Shortcut',
      rarity: 'rare',
      iconKey: 'obstacle.forklift',
      description: 'Clear hazards and gain a speed lane for 12 seconds.',
      apply(game) {
        game.clearNearestObstacles(3);
        game.addTimedEffect('shortcut', 12);
      }
    },
    {
      id: 'coupon-fever',
      title: 'Coupon Fever',
      rarity: 'premium',
      iconKey: 'qte.rush-order.resolved',
      description: 'Final 15 seconds score +25%.',
      apply(game) {
        game.effects.couponFever = true;
      }
    },
    {
      id: 'clean-floor',
      title: 'Clean Floor',
      rarity: 'common',
      iconKey: 'obstacle.oil',
      description: 'Oil spill duration is reduced by 40%.',
      apply(game) {
        game.effects.cleanFloor = true;
      }
    }
  ];

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function distance(a, b) {
    const dx = a.x - b.x;
    const dy = a.y - b.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function randomFrom(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function shouldAutoPickupTire(input) {
    if (!input || !input.tire || !input.primaryOrder) return false;
    if (input.step !== 'pick') return false;
    if (input.carriedCount >= input.maxCapacity) return false;
    if (input.tire.tireId !== input.primaryOrder.tireId) return false;
    const bonus = input.hasPerfectMatch ? WORLD_BALANCE.perfectMatchPickupBonus : 0;
    const pickupRadius = (input.pickupRadius || WORLD_BALANCE.pickupRadiusBase) + bonus;
    return input.distanceToPlayer <= pickupRadius;
  }

  function choosePrimaryOrder(orders, primaryOrderId, carried = []) {
    if (!orders || !orders.length) return null;
    const current = orders.find((order) => order.id === primaryOrderId);
    if (current && (!carried.length || carried.includes(current.tireId))) return current;
    const carriedMatch = orders.find((order) => carried.includes(order.tireId));
    if (carriedMatch) return carriedMatch;
    return current || orders[0];
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderCompactOrderCue(order, visual, isPrimary) {
    const step = visual && visual.step === 'drop' ? 'drop' : 'pick';
    const cue = step === 'drop' ? 'DROP' : 'PICK';
    const label = step === 'drop'
      ? `${visual.tireType.label} tire loaded. Follow the map to dock ${order.bayId}.`
      : `Pick ${visual.tireType.label} tire.`;
    const activeClass = isPrimary ? ' is-primary' : ' is-secondary';
    const stepClass = step === 'drop' ? ' is-drop' : ' is-pick';
    return `
      <button type="button" class="rush-order-card${activeClass}${stepClass}" data-rush-order-id="${escapeHtml(order.id)}" style="--tire-color:${escapeHtml(order.tireColor)}; --dock-color:${escapeHtml(order.bay.color)}" aria-label="${escapeHtml(label)}">
        <span class="rush-order-tire" data-sprite-key="${escapeHtml(visual.tireFrameKey)}" aria-hidden="true"></span>
        <span class="rush-order-copy" aria-hidden="true"><b>${isPrimary ? cue : ''}</b></span>
      </button>`;
  }

  function getPresetByName(name) {
    return CHARACTER_PRESETS.find((preset) => preset.name.toLowerCase() === String(name || '').toLowerCase()) || CHARACTER_PRESETS[0];
  }

  function calculateDeliveryScore(input) {
    if (!input.correct) {
      return -40;
    }
    const distanceBonus = Math.min(80, Math.floor((input.distance || 0) / 14));
    const timeBonus = Math.max(0, Math.floor(input.timeRemaining || 0) * 10);
    const comboBonus = Math.min(150, Math.floor((input.combo || 0) / 3) * 55);
    const multiplier = input.orderMultiplier || 1;
    return Math.round((100 + distanceBonus + timeBonus + comboBonus) * multiplier);
  }

  function getQteStage(elapsedSeconds) {
    if (elapsedSeconds < 15) {
      return null;
    }
    if (elapsedSeconds < 40) {
      return { id: 'early', windowSeconds: 3.5, inputSteps: 1, reward: 100 };
    }
    if (elapsedSeconds < 70) {
      return { id: 'mid', windowSeconds: 2.8, inputSteps: 2, reward: 160 };
    }
    return { id: 'late', windowSeconds: 2.2, inputSteps: 3, reward: 230 };
  }

  function applyQteOutcome(state, eventId, success, stage) {
    const reward = stage && stage.reward ? stage.reward : 120;
    if (success) {
      state.score += reward;
      state.combo += 1;
    }

    switch (eventId) {
      case 'tire-stack-collapse':
        if (!success) {
          state.obstacles.push({ type: 'tire-wall', x: 480, y: 300, radius: 44, ttl: 10 });
        }
        break;
      case 'van-trouble':
        if (success) {
          state.timeRemaining += 5;
          state.orderBoostUntil = Math.max(state.orderBoostUntil || 0, 6);
        } else {
          state.timeRemaining = Math.max(0, state.timeRemaining - 5);
          state.bayStallUntil = Math.max(state.bayStallUntil || 0, 5);
        }
        break;
      case 'forklift-jam':
        if (success) {
          state.shortcutUntil = Math.max(state.shortcutUntil || 0, 12);
        } else {
          state.obstacles.push({ type: 'forklift', x: 480, y: 300, radius: 52, ttl: 12 });
        }
        break;
      case 'wrong-sku-alert':
        if (success) {
          state.skuCorrected = true;
        } else {
          state.clearCurrentBonus = true;
        }
        break;
      case 'oil-spill':
        if (success) {
          state.speedBoostUntil = Math.max(state.speedBoostUntil || 0, 4);
        } else {
          state.slidingUntil = Math.max(state.slidingUntil || 0, 2);
        }
        break;
      case 'pallet-overload':
        if (success) {
          state.maxCapacityBonus = Math.max(state.maxCapacityBonus || 0, 1);
          state.capacityBonusUntil = Math.max(state.capacityBonusUntil || 0, 12);
        } else if (state.carried && state.carried.length) {
          state.carried.pop();
        }
        break;
      case 'rush-order':
        if (success) {
          state.rushOrder = true;
        }
        break;
      case 'safety-check':
        if (success) {
          state.clearHazards = true;
        } else {
          state.slowUntil = Math.max(state.slowUntil || 0, 2.5);
        }
        break;
      default:
        break;
    }
    return state;
  }

  function isCouponQualified(score, threshold) {
    return Number(score) >= Number(threshold);
  }

  const core = {
    TIRE_TYPES,
    ORDER_BAYS,
    WORLD_BALANCE,
    TIRE_SPAWN_ZONES,
    CHARACTER_PRESETS,
    QTE_EVENTS,
    UPGRADE_POOL,
    ATLAS_V2: ATLAS_V3,
    ATLAS_V3,
    calculateDeliveryScore,
    getQteStage,
    applyQteOutcome,
    isCouponQualified,
    getPresetByName,
    hasAtlasFrame,
    shouldAutoPickupTire,
    choosePrimaryOrder,
    renderCompactOrderCue
  };

  window.ToeeTireRushCore = core;

  class InputController {
    constructor(game) {
      this.game = game;
      this.keys = new Set();
      this.pointerTarget = null;
      this.joystick = { active: false, dx: 0, dy: 0, id: null };
      this.touchStart = null;
      this.bind();
    }

    bind() {
      window.addEventListener('keydown', (event) => {
        const key = event.key.toLowerCase();
        this.keys.add(key);
        if ([' ', 'arrowup', 'arrowdown', 'arrowleft', 'arrowright'].includes(key)) {
          event.preventDefault();
        }
        this.game.handleQteKey(key, true);
        if (key === 'e') {
          this.game.handleQteKey('e', true);
        }
        if (key === ' ' || key === 'spacebar') {
          this.game.activateSkill();
        }
      });

      window.addEventListener('keyup', (event) => {
        const key = event.key.toLowerCase();
        this.keys.delete(key);
        this.game.handleQteKey(key, false);
      });

      const canvas = this.game.canvas;
      canvas.addEventListener('pointerdown', (event) => this.setPointerTarget(event));
      canvas.addEventListener('pointermove', (event) => {
        if (event.buttons) {
          this.setPointerTarget(event);
        }
      });

      const stick = this.game.section.querySelector('[data-rush-joystick]');
      const knob = this.game.section.querySelector('[data-rush-joystick-knob]');
      if (stick && knob) {
        stick.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          const rect = stick.getBoundingClientRect();
          this.joystick.active = true;
          this.joystick.id = touch.identifier;
          this.joystick.cx = rect.left + rect.width / 2;
          this.joystick.cy = rect.top + rect.height / 2;
          this.updateJoystick(touch.clientX, touch.clientY, knob);
          event.preventDefault();
        }, { passive: false });

        window.addEventListener('touchmove', (event) => {
          if (!this.joystick.active) return;
          const touch = Array.from(event.changedTouches).find((item) => item.identifier === this.joystick.id);
          if (touch) {
            this.updateJoystick(touch.clientX, touch.clientY, knob);
            event.preventDefault();
          }
        }, { passive: false });

        window.addEventListener('touchend', (event) => {
          const touch = Array.from(event.changedTouches).find((item) => item.identifier === this.joystick.id);
          if (!touch) return;
          this.joystick.active = false;
          this.joystick.dx = 0;
          this.joystick.dy = 0;
          this.joystick.id = null;
          knob.style.transform = 'translate(0, 0)';
        });
      }
    }

    setPointerTarget(event) {
      const rect = this.game.canvas.getBoundingClientRect();
      this.pointerTarget = {
        x: ((event.clientX - rect.left) / rect.width) * LOGICAL_WIDTH,
        y: ((event.clientY - rect.top) / rect.height) * LOGICAL_HEIGHT
      };
    }

    updateJoystick(x, y, knob) {
      const dx = x - this.joystick.cx;
      const dy = y - this.joystick.cy;
      const length = Math.max(1, Math.sqrt(dx * dx + dy * dy));
      const capped = Math.min(length, 42);
      this.joystick.dx = (dx / length) * (capped / 42);
      this.joystick.dy = (dy / length) * (capped / 42);
      knob.style.transform = `translate(${this.joystick.dx * 42}px, ${this.joystick.dy * 42}px)`;
    }

    movementVector(player) {
      let x = 0;
      let y = 0;
      if (this.keys.has('w') || this.keys.has('arrowup')) y -= 1;
      if (this.keys.has('s') || this.keys.has('arrowdown')) y += 1;
      if (this.keys.has('a') || this.keys.has('arrowleft')) x -= 1;
      if (this.keys.has('d') || this.keys.has('arrowright')) x += 1;

      if (this.joystick.active) {
        x += this.joystick.dx;
        y += this.joystick.dy;
      }

      if (x === 0 && y === 0 && this.pointerTarget) {
        const dx = this.pointerTarget.x - player.x;
        const dy = this.pointerTarget.y - player.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist > 8) {
          x = dx / dist;
          y = dy / dist;
        }
      }

      const magnitude = Math.sqrt(x * x + y * y);
      if (magnitude > 1) {
        x /= magnitude;
        y /= magnitude;
      }
      return { x, y };
    }
  }

  class TireRushGame {
    constructor(section) {
      this.section = section;
      this.canvas = section.querySelector('[data-rush-canvas]');
      this.ctx = this.canvas.getContext('2d');
      this.canvas.width = LOGICAL_WIDTH;
      this.canvas.height = LOGICAL_HEIGHT;
      this.config = {
        duration: Number(section.dataset.duration || 90),
        couponThreshold: Number(section.dataset.couponThreshold || 3200),
        qteEnabled: section.dataset.qteEnabled !== 'false',
        qteIntensity: section.dataset.qteIntensity || 'standard',
        spriteUrl: section.dataset.spriteUrl || ''
      };
      this.elements = this.collectElements();
      this.input = new InputController(this);
      this.sprite = new Image();
      this.spriteLoaded = false;
      if (this.config.spriteUrl) {
        this.sprite.onload = () => {
          this.spriteLoaded = true;
          this.section.classList.add('is-atlas-ready');
          this.applySpriteBackgrounds();
        };
        this.sprite.onerror = () => {
          this.section.classList.add('is-atlas-fallback');
        };
        this.sprite.src = this.config.spriteUrl;
      }
      this.selectedCharacter = null;
      this.frameId = null;
      this.lastTimestamp = 0;
      this.qteHoldActive = false;
      this.bindUI();
      this.drawIdle();
      this.applySpriteBackgrounds();
    }

    collectElements() {
      return {
        selection: this.section.querySelector('[data-rush-selection]'),
        gameArea: this.section.querySelector('[data-rush-game]'),
        result: this.section.querySelector('[data-rush-result]'),
        selectedName: this.section.querySelector('[data-rush-selected-name]'),
        selectedTitle: this.section.querySelector('[data-rush-selected-title]'),
        timer: this.section.querySelector('[data-rush-timer]'),
        score: this.section.querySelector('[data-rush-score]'),
        combo: this.section.querySelector('[data-rush-combo]'),
        ordersDone: this.section.querySelector('[data-rush-orders-done]'),
        orders: this.section.querySelector('[data-rush-orders]'),
        carried: this.section.querySelector('[data-rush-carried]'),
        skill: this.section.querySelector('[data-rush-skill]'),
        skillName: this.section.querySelector('[data-rush-skill-name]'),
        skillCooldown: this.section.querySelector('[data-rush-skill-cooldown]'),
        qte: this.section.querySelector('[data-rush-qte]'),
        qteTitle: this.section.querySelector('[data-rush-qte-title]'),
        qtePrompt: this.section.querySelector('[data-rush-qte-prompt]'),
        qteGlyph: this.section.querySelector('[data-rush-qte-glyph]'),
        qteIcon: this.section.querySelector('[data-rush-qte-icon]'),
        qteTimer: this.section.querySelector('[data-rush-qte-timer]'),
        qteProgress: this.section.querySelector('[data-rush-qte-progress]'),
        qteActions: this.section.querySelector('[data-rush-qte-actions]'),
        tutorial: this.section.querySelector('[data-rush-tutorial]'),
        tutorialCountdown: this.section.querySelector('[data-rush-tutorial-countdown]'),
        tutorialStart: this.section.querySelector('[data-rush-tutorial-start]'),
        tutorialSkip: this.section.querySelector('[data-rush-tutorial-skip]'),
        upgrades: this.section.querySelector('[data-rush-upgrades]'),
        upgradeCards: this.section.querySelector('[data-rush-upgrade-cards]'),
        finalTitle: this.section.querySelector('[data-rush-final-title]'),
        finalScore: this.section.querySelector('[data-rush-final-score]'),
        finalOrders: this.section.querySelector('[data-rush-final-orders]'),
        finalCombo: this.section.querySelector('[data-rush-final-combo]'),
        finalQte: this.section.querySelector('[data-rush-final-qte]'),
        rewardPanel: this.section.querySelector('[data-rush-reward-panel]'),
        normalPanel: this.section.querySelector('[data-rush-normal-panel]'),
        hiddenCharacter: this.section.querySelector('[data-rush-form-character]'),
        hiddenScore: this.section.querySelector('[data-rush-form-score]'),
        hiddenOrders: this.section.querySelector('[data-rush-form-orders]'),
        hiddenCombo: this.section.querySelector('[data-rush-form-combo]'),
        hiddenQte: this.section.querySelector('[data-rush-form-qte]'),
        hiddenMessage: this.section.querySelector('[data-rush-form-message]')
      };
    }

    applySpriteBackground(element, key) {
      if (!element || !key || !this.config.spriteUrl) return;
      const frame = ATLAS_V3.frames[key];
      if (!frame) return;
      const width = Number(element.dataset.spriteWidth) || element.offsetWidth || frame.w;
      const height = Number(element.dataset.spriteHeight) || element.offsetHeight || frame.h;
      const scaleX = width / frame.w;
      const scaleY = height / frame.h;
      element.style.backgroundImage = `url("${this.config.spriteUrl}")`;
      element.style.backgroundSize = `${ATLAS_V3.width * scaleX}px ${ATLAS_V3.height * scaleY}px`;
      element.style.backgroundPosition = `-${frame.x * scaleX}px -${frame.y * scaleY}px`;
      element.style.backgroundRepeat = 'no-repeat';
    }

    applySpriteBackgrounds(root = this.section) {
      if (!root) return;
      root.querySelectorAll('[data-sprite-key]').forEach((element) => {
        this.applySpriteBackground(element, element.dataset.spriteKey);
      });
    }

    bindUI() {
      this.section.querySelectorAll('[data-rush-character-card]').forEach((card) => {
        const button = card.querySelector('[data-rush-select]');
        const handler = () => this.selectCharacter(card);
        button.addEventListener('click', handler);
        card.addEventListener('dblclick', handler);
      });

      this.section.querySelector('[data-rush-back]').addEventListener('click', () => this.backToSelection());
      this.section.querySelector('[data-rush-restart]').addEventListener('click', () => this.startRun());
      this.section.querySelector('[data-rush-change-character]').addEventListener('click', () => this.backToSelection());
      this.section.querySelector('[data-rush-how-to]').addEventListener('click', () => this.showTutorial(true));
      this.elements.orders.addEventListener('click', (event) => {
        const card = event.target.closest('[data-rush-order-id]');
        if (card) this.setPrimaryOrder(card.dataset.rushOrderId);
      });
      this.elements.skill.addEventListener('click', () => this.activateSkill());
      this.elements.tutorialStart.addEventListener('click', () => this.completeTutorial());
      this.elements.tutorialSkip.addEventListener('click', () => this.completeTutorial());

      this.section.querySelectorAll('[data-rush-mobile-qte]').forEach((button) => {
        button.addEventListener('pointerdown', () => this.handleQteAction(button.dataset.rushMobileQte, true));
        button.addEventListener('pointerup', () => this.handleQteAction(button.dataset.rushMobileQte, false));
        button.addEventListener('pointercancel', () => this.handleQteAction(button.dataset.rushMobileQte, false));
      });

      const form = this.section.querySelector('.tire-rush-reward-form');
      if (form) {
        form.addEventListener('submit', () => this.populateRewardForm());
      }
    }

    selectCharacter(card) {
      const preset = getPresetByName(card.dataset.characterName);
      this.selectedCharacter = {
        name: card.dataset.characterName || preset.name,
        title: card.dataset.characterTitle || preset.title,
        speed: Number(card.dataset.speed || preset.speed),
        handling: Number(card.dataset.handling || preset.handling),
        capacity: Number(card.dataset.capacity || preset.capacity),
        focus: Number(card.dataset.focus || preset.focus),
        luck: Number(card.dataset.luck || preset.luck),
        activeSkill: card.dataset.activeSkill || preset.activeSkill,
        activeDescription: card.dataset.activeDescription || preset.activeDescription,
        passiveSkill: card.dataset.passiveSkill || preset.passiveSkill,
        passiveDescription: card.dataset.passiveDescription || preset.passiveDescription,
        qteSpecialty: card.dataset.qteSpecialty || preset.qteSpecialty,
        cooldown: Number(card.dataset.cooldown || preset.cooldown)
      };

      this.section.querySelectorAll('[data-rush-character-card]').forEach((item) => item.classList.toggle('is-selected', item === card));
      this.elements.selectedName.textContent = this.selectedCharacter.name;
      this.elements.selectedTitle.textContent = this.selectedCharacter.title;
      this.elements.skillName.textContent = this.selectedCharacter.activeSkill;
      this.elements.gameArea.hidden = false;
      this.elements.result.hidden = true;
      this.elements.gameArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.startRun();
    }

    startRun() {
      if (!this.selectedCharacter) return;
      if (this.frameId) {
        cancelAnimationFrame(this.frameId);
      }
      this.mods = {
        speed: 0,
        handling: 0,
        capacity: 0,
        focus: 0,
        luck: 0,
        pickupRadius: WORLD_BALANCE.pickupRadiusBase,
        scoreMultiplier: 1,
        qteWindow: 0
      };
      this.effects = {
        comboInsurance: 0,
        firstPremiumUpgrade: this.selectedCharacter.name === 'Mandy Li',
        routeScanner: this.selectedCharacter.name === 'Richard Li',
        couponFever: false,
        cleanFloor: false
      };
      this.timedEffects = [];
      this.state = {
        playing: true,
        pausedForUpgrade: false,
        elapsed: 0,
        timeRemaining: this.config.duration,
        score: 0,
        combo: 0,
        maxCombo: 0,
        ordersCompleted: 0,
        qteSuccess: 0,
        qteTotal: 0,
        carried: [],
        maxCapacityBonus: 0,
        obstacles: [],
        particles: [],
        floaters: [],
        orders: [],
        tires: [],
        player: { x: LOGICAL_WIDTH / 2, y: LOGICAL_HEIGHT / 2, radius: 18, direction: 0, step: 0 },
        skillCooldownRemaining: 0,
        activeSkillUntil: 0,
        primaryOrderId: null,
        tutorialActive: false,
        tutorialStep: 0,
        tutorialRemaining: 0,
        wrongDropBayId: null,
        wrongDropWarningUntil: 0,
        lastQteAt: -99,
        qteNextDelay: 9,
        qteActive: null,
        nextUpgradeAt: 22,
        ordersAtLastUpgrade: 0,
        screenShake: 0
      };
      this.spawnCursor = Math.floor(Math.random() * TIRE_SPAWN_ZONES.length);
      this.spawnInitialWorld();
      this.hideQte();
      this.hideUpgrades();
      this.elements.result.hidden = true;
      if (this.shouldShowTutorial()) {
        this.showTutorial(false);
      } else {
        this.hideTutorial();
      }
      this.lastTimestamp = performance.now();
      this.frameId = requestAnimationFrame((time) => this.loop(time));
    }

    spawnInitialWorld() {
      this.state.orders = [];
      this.state.tires = [];
      this.state.obstacles = [
        this.makeObstacle('cone', 318, 160, 24, 99),
        this.makeObstacle('pallet', 650, 200, 34, 99),
        this.makeObstacle('oil', 510, 420, 36, 16)
      ];
      while (this.state.orders.length < 3) {
        this.addOrder();
      }
      this.ensurePrimaryTireAvailable();
      while (this.state.tires.length < WORLD_BALANCE.floorTireLimit) {
        this.addTire();
      }
    }

    makeObstacle(type, x, y, radius, ttl) {
      return { type, x, y, radius, ttl, pulse: Math.random() * TWO_PI };
    }

    addOrder(forceRush) {
      const tire = randomFrom(TIRE_TYPES);
      const bay = randomFrom(ORDER_BAYS);
      const rush = Boolean(forceRush);
      const order = {
        id: `${Date.now()}-${Math.random()}`,
        tireId: tire.id,
        tireLabel: tire.label,
        tireShort: tire.short,
        tireColor: tire.color,
        bayId: bay.id,
        bay,
        createdAt: this.state.elapsed,
        bonusSeconds: rush ? 10 : 18 + Math.random() * 8,
        multiplier: rush ? 1.75 : 1 + Math.random() * 0.25
      };
      this.state.orders.push(order);
      if (!this.state.primaryOrderId) this.state.primaryOrderId = order.id;
    }

    addTire(typeId) {
      const tire = typeId ? TIRE_TYPES.find((item) => item.id === typeId) : randomFrom(TIRE_TYPES);
      const position = this.nextTireSpawnPosition();
      this.state.tires.push({
        id: `${Date.now()}-${Math.random()}`,
        tireId: tire.id,
        label: tire.label,
        short: tire.short,
        color: tire.color,
        accent: tire.accent,
        badgeKey: tire.badgeKey,
        x: position.x,
        y: position.y,
        radius: 15,
        spin: Math.random() * TWO_PI,
        pull: 0
      });
    }

    nextTireSpawnPosition() {
      const player = this.state && this.state.player ? this.state.player : { x: LOGICAL_WIDTH / 2, y: LOGICAL_HEIGHT / 2 };
      let fallback = TIRE_SPAWN_ZONES[0];
      for (let attempt = 0; attempt < TIRE_SPAWN_ZONES.length * 2; attempt += 1) {
        const zone = TIRE_SPAWN_ZONES[(this.spawnCursor + attempt) % TIRE_SPAWN_ZONES.length];
        const x = clamp(zone.x + (Math.random() - 0.5) * zone.jitterX, 54, LOGICAL_WIDTH - 54);
        const y = clamp(zone.y + (Math.random() - 0.5) * zone.jitterY, 78, LOGICAL_HEIGHT - 72);
        const candidate = { x, y };
        fallback = candidate;
        if (distance(candidate, player) < WORLD_BALANCE.tireSpawnMinDistanceFromPlayer) continue;
        if (ORDER_BAYS.some((bay) => distance(candidate, bay) < WORLD_BALANCE.tireSpawnMinDistanceFromBay)) continue;
        if (this.state.tires.some((tire) => distance(candidate, tire) < WORLD_BALANCE.tireSpawnMinSpacing)) continue;
        this.spawnCursor = (this.spawnCursor + attempt + 1) % TIRE_SPAWN_ZONES.length;
        return candidate;
      }
      this.spawnCursor = (this.spawnCursor + 1) % TIRE_SPAWN_ZONES.length;
      return fallback;
    }

    loop(timestamp) {
      const rawDelta = Math.min(0.05, (timestamp - this.lastTimestamp) / 1000 || 0.016);
      this.lastTimestamp = timestamp;
      if (this.state.playing && this.state.tutorialActive) {
        this.updateTutorial(rawDelta);
      } else if (this.state.playing && !this.state.pausedForUpgrade) {
        const timeScale = this.state.qteActive ? 0.65 : 1;
        this.update(rawDelta * timeScale, rawDelta);
      }
      this.render(rawDelta);
      this.updateHud();
      if (this.state.playing) {
        this.frameId = requestAnimationFrame((time) => this.loop(time));
      }
    }

    update(dt, realDt) {
      this.state.elapsed += dt;
      this.state.timeRemaining = Math.max(0, this.state.timeRemaining - dt);
      this.state.skillCooldownRemaining = Math.max(0, this.state.skillCooldownRemaining - realDt);
      this.updateTimedEffects(dt);
      this.updatePlayer(dt);
      this.updateWorld(dt);
      this.updateQte(realDt);
      this.maybeStartQte();
      this.maybeShowUpgrade();
      if (this.state.timeRemaining <= 0) {
        this.finishRun();
      }
    }

    updateTimedEffects(dt) {
      this.timedEffects.forEach((effect) => {
        effect.remaining -= dt;
      });
      this.timedEffects = this.timedEffects.filter((effect) => effect.remaining > 0);
      ['orderBoostUntil', 'shortcutUntil', 'speedBoostUntil', 'slidingUntil', 'slowUntil', 'bayStallUntil', 'capacityBonusUntil'].forEach((key) => {
        if (this.state[key]) {
          this.state[key] = Math.max(0, this.state[key] - dt);
        }
      });
      if (this.state.capacityBonusUntil === 0) {
        this.state.maxCapacityBonus = 0;
      }
      if (this.state.activeSkillUntil > 0) {
        this.state.activeSkillUntil = Math.max(0, this.state.activeSkillUntil - dt);
      }
    }

    updatePlayer(dt) {
      const vector = this.input.movementVector(this.state.player);
      let speed = 138 + (this.selectedCharacter.speed + this.mods.speed) * 11;
      if (this.selectedCharacter.name === 'Sanat Khare' && this.state.timeRemaining < 20) speed *= 1.12;
      if (this.hasEffect('sprint') || this.hasEffect('nitro') || this.state.speedBoostUntil > 0) speed *= 1.72;
      if (this.hasEffect('carry-more')) speed *= 0.92;
      if (this.state.slowUntil > 0) speed *= 0.55;
      if (this.state.slidingUntil > 0 && !this.effects.grip) {
        speed *= 1.2;
        vector.x = vector.x * 0.35 + Math.cos(this.state.player.direction) * 0.65;
        vector.y = vector.y * 0.35 + Math.sin(this.state.player.direction) * 0.65;
      }
      this.state.player.x = clamp(this.state.player.x + vector.x * speed * dt, 38, LOGICAL_WIDTH - 38);
      this.state.player.y = clamp(this.state.player.y + vector.y * speed * dt, 64, LOGICAL_HEIGHT - 42);
      if (Math.abs(vector.x) + Math.abs(vector.y) > 0.02) {
        this.state.player.direction = Math.atan2(vector.y, vector.x);
        this.state.player.step += dt * speed / 28;
      }
    }

    updateWorld(dt) {
      this.state.tires.forEach((tire) => {
        tire.spin += dt * 2.5;
      });
      this.state.obstacles.forEach((obstacle) => {
        obstacle.ttl -= dt;
        obstacle.pulse += dt * 3;
      });
      this.state.obstacles = this.state.obstacles.filter((obstacle) => obstacle.ttl > 0);

      this.state.particles.forEach((particle) => {
        particle.x += particle.vx * dt;
        particle.y += particle.vy * dt;
        particle.life -= dt;
        particle.rotation += (particle.spin || 0) * dt;
      });
      this.state.particles = this.state.particles.filter((particle) => particle.life > 0);

      this.state.floaters.forEach((floater) => {
        floater.y -= dt * 35;
        floater.life -= dt;
      });
      this.state.floaters = this.state.floaters.filter((floater) => floater.life > 0);

      this.checkPickups();
      this.checkDeliveries();
      this.checkObstacleImpacts(dt);

      while (this.state.orders.length < 3) this.addOrder();
      this.ensurePrimaryTireAvailable();
      while (this.state.tires.length < WORLD_BALANCE.floorTireLimit) this.addTire();
    }

    checkPickups() {
      const maxCapacity = this.maxCapacity();
      const primary = this.getPrimaryOrder();
      const step = this.getPlayerStepForOrder(primary);
      for (let index = this.state.tires.length - 1; index >= 0; index -= 1) {
        const tire = this.state.tires[index];
        const distanceToPlayer = distance(tire, this.state.player);
        if (shouldAutoPickupTire({
          tire,
          primaryOrder: primary,
          step,
          carriedCount: this.state.carried.length,
          maxCapacity,
          distanceToPlayer,
          pickupRadius: this.mods.pickupRadius,
          hasPerfectMatch: this.hasEffect('perfect-match')
        })) {
          this.state.carried.push(tire.tireId);
          this.state.tires.splice(index, 1);
          this.addParticles(tire.x, tire.y, tire.color, 12, 'spark');
          this.addIconFloater(tire.badgeKey, tire.x, tire.y, tire.color);
        }
      }
    }

    ensurePrimaryTireAvailable() {
      const primary = this.getPrimaryOrder();
      if (!primary || this.getPlayerStepForOrder(primary) !== 'pick') return;
      if (this.state.tires.some((tire) => tire.tireId === primary.tireId)) return;
      if (this.state.carried.includes(primary.tireId)) return;
      if (this.state.tires.length >= WORLD_BALANCE.floorTireLimit) {
        const replaceIndex = this.state.tires.findIndex((tire) => tire.tireId !== primary.tireId);
        if (replaceIndex >= 0) this.state.tires.splice(replaceIndex, 1);
      }
      this.addTire(primary.tireId);
    }

    checkDeliveries() {
      const primary = this.getPrimaryOrder();
      const primaryStep = this.getPlayerStepForOrder(primary);
      for (const bay of ORDER_BAYS) {
        if (distance(bay, this.state.player) > bay.dropRadius) continue;
        const canCompletePrimary = primary && primaryStep === 'drop' && primary.bayId === bay.id && this.state.carried.includes(primary.tireId);
        if (canCompletePrimary) {
          const orderIndex = this.state.orders.findIndex((order) => order.id === primary.id);
          const order = this.state.orders[orderIndex];
          const carriedIndex = this.state.carried.indexOf(order.tireId);
          this.state.carried.splice(carriedIndex, 1);
          this.state.orders.splice(orderIndex, 1);
          if (this.state.primaryOrderId === order.id) this.state.primaryOrderId = null;
          this.completeOrder(order);
          return;
        }
        if (this.state.carried.length > 0) {
          if (this.state.wrongDropBayId !== bay.id) {
            this.state.wrongDropBayId = bay.id;
            this.state.wrongDropWarningUntil = this.state.elapsed + 0.4;
            this.addIconFloater('guide.noEntry', bay.x, bay.y - 50, '#ff6262');
            return;
          }
          if (this.state.elapsed < this.state.wrongDropWarningUntil) return;
          this.wrongDelivery(bay);
          this.state.wrongDropBayId = null;
          this.state.wrongDropWarningUntil = 0;
          return;
        }
      }
      this.state.wrongDropBayId = null;
      this.state.wrongDropWarningUntil = 0;
    }

    completeOrder(order) {
      const elapsedForOrder = Math.max(0, this.state.elapsed - order.createdAt);
      const timeRemaining = Math.max(0, order.bonusSeconds - elapsedForOrder);
      const distBonus = distance(order.bay, this.state.player);
      let multiplier = order.multiplier * this.mods.scoreMultiplier;
      if (this.hasEffect('executive-dispatch') || this.state.orderBoostUntil > 0) multiplier *= 1.35;
      if (this.selectedCharacter.name === 'Jeff Thorup') multiplier *= 1 + Math.min(0.3, distBonus / 1200);
      if (this.effects.couponFever && this.state.timeRemaining <= 15) multiplier *= 1.25;
      const points = calculateDeliveryScore({
        correct: true,
        distance: distBonus,
        timeRemaining,
        combo: this.state.combo,
        orderMultiplier: multiplier
      });
      this.state.score += points;
      this.state.combo += 1;
      this.state.maxCombo = Math.max(this.state.maxCombo, this.state.combo);
      this.state.ordersCompleted += 1;
      if (this.selectedCharacter.name === 'Arshdeep Singh' && this.state.combo % 4 === 0) {
        this.state.timeRemaining = Math.min(this.config.duration + 8, this.state.timeRemaining + 1);
      }
      this.addParticles(order.bay.x, order.bay.y, order.tireColor, 26, 'burst');
      this.addFloater(`+${points}`, order.bay.x, order.bay.y - 20, '#ffffff');
      this.state.screenShake = Math.max(this.state.screenShake, 4);
    }

    wrongDelivery(bay) {
      this.state.score = Math.max(0, this.state.score + calculateDeliveryScore({ correct: false }));
      if (this.hasEffect('steady-mode')) {
        this.addIconFloater('guide.check', bay.x, bay.y, '#7fc8ff');
      } else if (this.effects.comboInsurance > 0) {
        this.effects.comboInsurance -= 1;
        this.addIconFloater('guide.check', bay.x, bay.y, '#ffd166');
      } else {
        if (this.selectedCharacter.name === 'Dustin Corbierre') {
          this.state.combo = Math.floor(this.state.combo * 0.4);
        } else {
          this.state.combo = 0;
        }
      }
      this.addIconFloater('guide.noEntry', bay.x, bay.y, '#ff6262');
      this.state.screenShake = Math.max(this.state.screenShake, 8);
    }

    checkObstacleImpacts(dt) {
      for (const obstacle of this.state.obstacles) {
        if (distance(obstacle, this.state.player) > obstacle.radius + this.state.player.radius) continue;
        if (this.hasEffect('sprint') || this.hasEffect('nitro') || this.hasEffect('shield')) {
          this.addParticles(obstacle.x, obstacle.y, '#ffd166', 10, 'spark');
          obstacle.ttl = Math.min(obstacle.ttl, 0.2);
          continue;
        }
        if (obstacle.type === 'oil') {
          this.state.slidingUntil = Math.max(this.state.slidingUntil, this.effects.cleanFloor ? 0.8 : 1.6);
        } else {
          this.state.slowUntil = Math.max(this.state.slowUntil, this.hasEffect('steady-mode') ? 0.3 : 1.4);
          this.state.timeRemaining = Math.max(0, this.state.timeRemaining - dt * (this.hasEffect('steady-mode') ? 0.5 : 1.2));
        }
      }
    }

    maybeStartQte() {
      if (!this.config.qteEnabled || this.state.qteActive || this.state.pausedForUpgrade) return;
      const stage = getQteStage(this.state.elapsed);
      if (!stage) return;
      const intensityOffset = this.config.qteIntensity === 'intense' ? -2 : this.config.qteIntensity === 'relaxed' ? 3 : 0;
      if (this.state.elapsed - this.state.lastQteAt < this.state.qteNextDelay + intensityOffset) return;
      this.startQte(stage);
    }

    startQte(stage) {
      const pool = stage.id === 'early' ? QTE_EVENTS.filter((event) => event.simple) : QTE_EVENTS;
      let event = randomFrom(pool);
      if (this.selectedCharacter.qteSpecialty && Math.random() < 0.2 + this.selectedCharacter.luck * 0.015) {
        const specialty = QTE_EVENTS.find((item) => this.selectedCharacter.qteSpecialty.toLowerCase().includes(item.name.toLowerCase()));
        if (specialty) event = specialty;
      }
      const windowBonus = this.mods.qteWindow + Math.floor((this.selectedCharacter.focus + this.mods.focus) / 2) * 0.15;
      const qte = {
        ...event,
        stage,
        remaining: stage.windowSeconds + windowBonus,
        duration: stage.windowSeconds + windowBonus,
        progress: 0,
        required: event.type === 'rapid' ? 4 + stage.inputSteps * 2 : 1,
        sequence: this.makeQteSequence(stage.inputSteps),
        sequenceIndex: 0,
        targetTire: randomFrom(TIRE_TYPES),
        resolved: false
      };
      this.state.qteActive = qte;
      this.state.qteTotal += 1;
      this.state.lastQteAt = this.state.elapsed;
      this.state.qteNextDelay = 8 + Math.random() * 5;
      this.renderQte();
    }

    makeQteSequence(steps) {
      const keys = ['arrowup', 'arrowright', 'arrowdown', 'arrowleft'];
      return Array.from({ length: steps }, () => randomFrom(keys));
    }

    updateQte(dt) {
      const qte = this.state.qteActive;
      if (!qte) return;
      if (qte.resolved) return;
      qte.remaining -= dt;
      if (qte.type === 'hold' && this.qteHoldActive) {
        qte.progress += dt / Math.max(0.6, qte.duration * 0.42);
      }
      if (qte.type === 'zone' && this.qteHoldActive && distance(this.state.player, { x: LOGICAL_WIDTH / 2, y: LOGICAL_HEIGHT / 2 }) < 110) {
        qte.progress += dt / 0.85;
      }
      if (qte.type === 'timed') {
        qte.pulse = ((qte.duration - qte.remaining) * 1.8) % 1;
      }
      if (qte.progress >= 1) {
        this.resolveQte(true);
      } else if (qte.remaining <= 0) {
        this.resolveQte(false);
      } else {
        this.renderQte();
      }
    }

    handleQteKey(key, down) {
      const normalized = key === 'spacebar' ? ' ' : key;
      if (!this.state || !this.state.qteActive) return;
      if (normalized === 'e') {
        this.qteHoldActive = down;
      }
      if (!down) return;
      if (normalized === ' ') {
        this.handleQteAction('tap', true);
      }
      if (['arrowup', 'arrowright', 'arrowdown', 'arrowleft'].includes(normalized)) {
        this.handleQteAction(normalized, true);
      }
    }

    handleQteAction(action, down) {
      const qte = this.state && this.state.qteActive;
      if (!qte || qte.resolved) return;
      if (!down && action !== 'hold') return;
      if (action === 'hold') {
        this.qteHoldActive = down;
        return;
      }
      if (qte.type === 'rapid' && action === 'tap') {
        qte.progress = Math.min(1, qte.progress + 1 / qte.required);
        if (qte.progress >= 0.999) qte.progress = 1;
      } else if (qte.type === 'sequence') {
        if (action === qte.sequence[qte.sequenceIndex]) {
          qte.sequenceIndex += 1;
          qte.progress = qte.sequenceIndex / qte.sequence.length;
        } else if (['arrowup', 'arrowright', 'arrowdown', 'arrowleft'].includes(action)) {
          qte.progress = Math.max(0, qte.progress - 0.25);
        }
      } else if (qte.type === 'choice') {
        this.resolveQte(action === qte.targetTire.id);
      } else if (qte.type === 'dodge' && ['arrowup', 'arrowright', 'arrowdown', 'arrowleft'].includes(action)) {
        this.resolveQte(true);
      } else if (qte.type === 'rush') {
        this.resolveQte(action === 'accept');
      } else if (qte.type === 'timed') {
        const inZone = qte.pulse > 0.42 && qte.pulse < 0.62;
        if (inZone) qte.progress += 0.5;
        else qte.progress = Math.max(0, qte.progress - 0.2);
      }
      if (qte.progress >= 1) {
        this.resolveQte(true);
      } else {
        this.renderQte();
      }
    }

    resolveQte(success) {
      const qte = this.state.qteActive;
      if (!qte || qte.resolved) return;
      qte.resolved = true;
      applyQteOutcome(this.state, qte.id, success, qte.stage);
      if (success) {
        this.state.qteSuccess += 1;
        this.addParticles(this.state.player.x, this.state.player.y, '#ffd166', 28, 'burst');
        if (qte.id === 'rush-order') this.addOrder(true);
        if (qte.id === 'safety-check') this.clearNearestObstacles(3);
      } else if (this.selectedCharacter.name === 'Anmol Gulshi' && ['pallet-overload', 'tire-stack-collapse'].includes(qte.id)) {
        this.state.timeRemaining = Math.min(this.config.duration, this.state.timeRemaining + 1);
      }
      this.addIconFloater(success ? 'guide.check' : 'guide.fail', this.state.player.x, this.state.player.y - 45, success ? '#69db7c' : '#ff6262');
      this.state.screenShake = Math.max(this.state.screenShake, success ? 5 : 11);
      this.hideQte();
      this.qteHoldActive = false;
      setTimeout(() => {
        if (this.state && this.state.qteActive === qte) {
          this.state.qteActive = null;
          this.hideQte();
        }
      }, 450);
    }

    renderQte() {
      const qte = this.state.qteActive;
      if (!qte) return;
      this.elements.qte.hidden = false;
      this.elements.qte.setAttribute('aria-label', `${qte.name}: ${this.isTouchDevice() ? qte.mobilePrompt : qte.prompt}`);
      this.elements.qteTitle.textContent = '';
      this.elements.qtePrompt.textContent = '';
      this.elements.qteGlyph.textContent = '';
      this.elements.qteGlyph.dataset.spriteKey = this.isTouchDevice() ? qte.mobileInputFrameKey : qte.desktopInputFrameKey;
      this.elements.qteTimer.style.setProperty('--qte-progress', `${Math.max(0, qte.remaining / qte.duration) * 100}%`);
      this.elements.qteProgress.style.width = `${clamp(qte.progress, 0, 1) * 100}%`;
      this.elements.qteIcon.dataset.spriteKey = qte.eventFrameKey;
      this.elements.qteActions.innerHTML = '';
      if (qte.type === 'choice') {
        const choices = [qte.targetTire, ...TIRE_TYPES.filter((type) => type.id !== qte.targetTire.id).slice(0, 2)].sort(() => Math.random() - 0.5);
        choices.forEach((type) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rush-qte-choice rush-qte-sprite-choice';
          button.dataset.spriteKey = type.badgeKey;
          button.setAttribute('aria-label', `${type.label} tire`);
          button.innerHTML = `<span class="rush-sr-only">${escapeHtml(type.label)} tire</span>`;
          button.style.setProperty('--choice-color', type.color);
          button.addEventListener('click', () => this.handleQteAction(type.id, true));
          this.elements.qteActions.appendChild(button);
        });
      } else if (qte.type === 'sequence') {
        qte.sequence.forEach((key, index) => {
          const item = document.createElement('span');
          item.className = `rush-qte-key ${index < qte.sequenceIndex ? 'is-complete' : ''}`;
          item.dataset.spriteKey = 'input.arrows';
          item.setAttribute('aria-label', key.replace('arrow', 'arrow '));
          this.elements.qteActions.appendChild(item);
        });
      } else if (qte.type === 'rush') {
        ['accept', 'skip'].forEach((action) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'rush-qte-choice';
          button.dataset.spriteKey = action === 'accept' ? 'input.accept' : 'input.skip';
          button.setAttribute('aria-label', action);
          button.innerHTML = `<span class="rush-sr-only">${action}</span>`;
          button.addEventListener('click', () => this.handleQteAction(action, true));
          this.elements.qteActions.appendChild(button);
        });
      }
      this.applySpriteBackgrounds(this.elements.qte);
    }

    hideQte() {
      this.elements.qte.hidden = true;
      this.elements.qteActions.innerHTML = '';
    }

    shouldShowTutorial() {
      try {
        return window.sessionStorage && window.sessionStorage.getItem('tireRushTutorialSeen') !== '1';
      } catch (error) {
        return true;
      }
    }

    showTutorial(manual) {
      if (!this.state) return;
      this.state.tutorialActive = true;
      this.state.tutorialStep = 0;
      this.state.tutorialRemaining = 10;
      this.elements.tutorial.hidden = false;
      this.elements.tutorialStart.textContent = '▶';
      this.elements.tutorialStart.setAttribute('aria-label', manual ? 'Resume run' : 'Start run');
      this.renderTutorial();
    }

    updateTutorial(dt) {
      if (!this.state.tutorialActive) return;
      this.state.tutorialRemaining = Math.max(0, this.state.tutorialRemaining - dt);
      this.state.tutorialStep = Math.min(2, Math.floor((10 - this.state.tutorialRemaining) / 3.34));
      this.renderTutorial();
      if (this.state.tutorialRemaining <= 0) {
        this.completeTutorial();
      }
    }

    renderTutorial() {
      if (!this.elements.tutorial || this.elements.tutorial.hidden) return;
      this.elements.tutorialCountdown.textContent = String(Math.max(0, Math.ceil(this.state.tutorialRemaining)));
      this.section.querySelectorAll('[data-rush-tutorial-step]').forEach((step) => {
        step.classList.toggle('is-active', Number(step.dataset.rushTutorialStep) === this.state.tutorialStep);
      });
      this.applySpriteBackgrounds(this.elements.tutorial);
    }

    completeTutorial() {
      if (!this.state) return;
      this.state.tutorialActive = false;
      this.state.tutorialRemaining = 0;
      this.hideTutorial();
      try {
        if (window.sessionStorage) window.sessionStorage.setItem('tireRushTutorialSeen', '1');
      } catch (error) {
        // Session storage can be unavailable in strict privacy contexts.
      }
      this.lastTimestamp = performance.now();
    }

    hideTutorial() {
      if (this.elements.tutorial) this.elements.tutorial.hidden = true;
    }

    maybeShowUpgrade() {
      if (this.state.pausedForUpgrade) return;
      const dueByTime = this.state.elapsed >= this.state.nextUpgradeAt;
      const dueByOrders = this.state.ordersCompleted >= this.state.ordersAtLastUpgrade + 4 && this.state.ordersCompleted > 0;
      if (!dueByTime && !dueByOrders) return;
      this.showUpgrades();
    }

    showUpgrades() {
      this.state.pausedForUpgrade = true;
      const choices = this.pickUpgrades();
      this.elements.upgradeCards.innerHTML = '';
      choices.forEach((upgrade) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = `rush-upgrade-card rarity-${upgrade.rarity}`;
        button.setAttribute('aria-label', `${upgrade.title}: ${upgrade.description}`);
        button.innerHTML = `
          <span class="rush-upgrade-rarity">${escapeHtml(upgrade.rarity)}</span>
          <i class="rush-upgrade-icon" data-sprite-key="${escapeHtml(upgrade.iconKey)}" aria-hidden="true"></i>
          <strong>${escapeHtml(upgrade.title)}</strong>
          <small>${escapeHtml(upgrade.description)}</small>`;
        button.addEventListener('click', () => {
          upgrade.apply(this);
          this.state.pausedForUpgrade = false;
          this.state.nextUpgradeAt = this.state.elapsed + 20;
          this.state.ordersAtLastUpgrade = this.state.ordersCompleted;
          this.hideUpgrades();
          this.addFloater(upgrade.title, this.state.player.x, this.state.player.y - 50, '#ffd166');
        });
        this.elements.upgradeCards.appendChild(button);
      });
      this.applySpriteBackgrounds(this.elements.upgradeCards);
      this.elements.upgrades.hidden = false;
    }

    pickUpgrades() {
      const pool = [...UPGRADE_POOL];
      const choices = [];
      if (this.effects.firstPremiumUpgrade) {
        choices.push(UPGRADE_POOL.find((upgrade) => upgrade.rarity === 'premium'));
        this.effects.firstPremiumUpgrade = false;
      }
      while (choices.length < 3) {
        const luck = this.selectedCharacter.luck + this.mods.luck;
        const rares = pool.filter((upgrade) => upgrade.rarity !== 'common');
        const pickRare = Math.random() < 0.18 + luck * 0.018 || this.selectedCharacter.name === 'Dakota Du' && Math.random() < 0.12;
        const choice = pickRare && rares.length ? randomFrom(rares) : randomFrom(pool);
        if (!choices.some((upgrade) => upgrade.id === choice.id)) choices.push(choice);
      }
      return choices;
    }

    hideUpgrades() {
      this.elements.upgrades.hidden = true;
    }

    activateSkill() {
      if (!this.state || !this.state.playing || this.state.skillCooldownRemaining > 0) return;
      const character = this.selectedCharacter;
      this.state.skillCooldownRemaining = Math.max(5, character.cooldown - (character.focus + this.mods.focus) * 0.45);
      switch (character.name) {
        case 'Mandy Li':
          this.addTimedEffect('executive-dispatch', 8);
          this.autoCompleteLowestOrder();
          break;
        case 'Jarvan Chen':
          this.addTimedEffect('perfect-match', 6);
          this.effects.forgiveWrongPickup = true;
          break;
        case 'Arshdeep Singh':
          this.addTimedEffect('sprint', 4);
          break;
        case 'Anmol Gulshi':
          this.addTimedEffect('power-load', 8);
          this.addTimedEffect('shield', 8);
          this.state.maxCapacityBonus = Math.max(this.state.maxCapacityBonus, 2);
          this.state.capacityBonusUntil = Math.max(this.state.capacityBonusUntil || 0, 8);
          break;
        case 'Richard Li':
          this.refreshLowestOrder();
          this.clearNearestObstacles(1);
          break;
        case 'Cedrick Sun':
          this.addTimedEffect('adapt', 10);
          this.mods.scoreMultiplier += 0.04;
          break;
        case 'Sanat Khare':
          this.addTimedEffect('steady-mode', 7);
          break;
        case 'Jeff Thorup':
          this.addTimedEffect('nitro', 5);
          break;
        case 'Dustin Corbierre':
          this.addTimedEffect('carry-more', 10);
          this.state.maxCapacityBonus = Math.max(this.state.maxCapacityBonus, 3);
          this.state.capacityBonusUntil = Math.max(this.state.capacityBonusUntil || 0, 10);
          break;
        case 'Dakota Du':
          this.smartLayout();
          break;
        default:
          this.addTimedEffect('sprint', 4);
          break;
      }
      this.addParticles(this.state.player.x, this.state.player.y, '#4f8cff', 32, 'ring');
    }

    addTimedEffect(id, seconds) {
      const existing = this.timedEffects.find((effect) => effect.id === id);
      if (existing) {
        existing.remaining = Math.max(existing.remaining, seconds);
      } else {
        this.timedEffects.push({ id, remaining: seconds });
      }
    }

    hasEffect(id) {
      return this.timedEffects.some((effect) => effect.id === id && effect.remaining > 0);
    }

    autoCompleteLowestOrder() {
      if (!this.state.orders.length) return;
      const order = [...this.state.orders].sort((a, b) => a.multiplier - b.multiplier)[0];
      this.state.orders = this.state.orders.filter((item) => item.id !== order.id);
      this.completeOrder(order);
    }

    refreshLowestOrder() {
      if (!this.state.orders.length) return;
      this.state.orders.sort((a, b) => a.multiplier - b.multiplier).shift();
      this.addOrder();
    }

    smartLayout() {
      this.state.orders.forEach((order, index) => {
        const tire = this.state.tires.find((item) => item.tireId === order.tireId);
        if (tire) {
          tire.x = clamp(this.state.player.x + 70 + index * 36, 80, LOGICAL_WIDTH - 80);
          tire.y = clamp(this.state.player.y - 70 + index * 28, 90, LOGICAL_HEIGHT - 80);
        } else {
          this.addTire(order.tireId);
        }
      });
      this.addTimedEffect('route-scanner', 8);
    }

    clearNearestObstacles(count) {
      this.state.obstacles.sort((a, b) => distance(a, this.state.player) - distance(b, this.state.player));
      const removed = this.state.obstacles.splice(0, count);
      removed.forEach((obstacle) => this.addParticles(obstacle.x, obstacle.y, '#ffd166', 18, 'burst'));
    }

    getPrimaryOrder() {
      if (!this.state || !this.state.orders.length) return null;
      const next = choosePrimaryOrder(this.state.orders, this.state.primaryOrderId, this.state.carried);
      this.state.primaryOrderId = next ? next.id : null;
      return next;
    }

    setPrimaryOrder(orderId) {
      if (!this.state || !this.state.orders.some((order) => order.id === orderId)) return;
      this.state.primaryOrderId = orderId;
      this.updateHud();
    }

    getPlayerStepForOrder(order) {
      if (!order) return 'pick';
      return this.state.carried.includes(order.tireId) ? 'drop' : 'pick';
    }

    getTireType(tireId) {
      return TIRE_TYPES.find((type) => type.id === tireId) || TIRE_TYPES[0];
    }

    getPrimaryOrderVisualState(order = this.getPrimaryOrder()) {
      if (!order) return null;
      const tireType = this.getTireType(order.tireId);
      const dockIndex = ORDER_BAYS.findIndex((bay) => bay.id === order.bayId);
      return {
        order,
        tireType,
        step: this.getPlayerStepForOrder(order),
        tireFrameKey: this.tireFrameKey(order.tireId, 0),
        badgeKey: tireType.badgeKey,
        dockIndex: Math.max(0, dockIndex),
        dockColor: order.bay.color
      };
    }

    findNearestTireForOrder(order) {
      if (!order) return null;
      const matches = this.state.tires.filter((tire) => tire.tireId === order.tireId);
      if (!matches.length) return null;
      return matches.sort((a, b) => distance(a, this.state.player) - distance(b, this.state.player))[0];
    }

    maxCapacity() {
      return Math.max(1, this.selectedCharacter.capacity + this.mods.capacity + (this.state.maxCapacityBonus || 0));
    }

    addParticles(x, y, color, amount, type) {
      const max = this.isTouchDevice() ? 120 : 240;
      for (let index = 0; index < amount; index += 1) {
        const angle = Math.random() * TWO_PI;
        const speed = type === 'ring' ? 80 + Math.random() * 80 : 35 + Math.random() * 120;
        this.state.particles.push({
          x,
          y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          life: 0.45 + Math.random() * 0.65,
          maxLife: 1,
          color,
          radius: 2 + Math.random() * 5,
          rotation: 0,
          spin: Math.random() * 4 - 2,
          type
        });
      }
      if (this.state.particles.length > max) {
        this.state.particles.splice(0, this.state.particles.length - max);
      }
    }

    addFloater(text, x, y, color) {
      this.state.floaters.push({ text, x, y, color, life: 1.15 });
    }

    addIconFloater(iconKey, x, y, color) {
      this.state.floaters.push({ iconKey, x, y, color, life: 0.85 });
    }

    finishRun() {
      this.state.playing = false;
      cancelAnimationFrame(this.frameId);
      this.frameId = null;
      this.hideTutorial();
      const qualified = isCouponQualified(this.state.score, this.config.couponThreshold);
      this.elements.result.hidden = false;
      this.elements.finalTitle.textContent = qualified ? 'Coupon route unlocked' : 'Warehouse report';
      this.elements.finalScore.textContent = Math.round(this.state.score).toLocaleString();
      this.elements.finalOrders.textContent = String(this.state.ordersCompleted);
      this.elements.finalCombo.textContent = String(this.state.maxCombo);
      const qteRate = this.state.qteTotal ? Math.round((this.state.qteSuccess / this.state.qteTotal) * 100) : 0;
      this.elements.finalQte.textContent = `${this.state.qteSuccess}/${this.state.qteTotal} (${qteRate}%)`;
      this.elements.rewardPanel.hidden = !qualified;
      this.elements.normalPanel.hidden = qualified;
      this.populateRewardForm();
      this.elements.result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    populateRewardForm() {
      if (!this.state || !this.selectedCharacter) return;
      const qteRate = this.state.qteTotal ? Math.round((this.state.qteSuccess / this.state.qteTotal) * 100) : 0;
      this.elements.hiddenCharacter.value = this.selectedCharacter.name;
      this.elements.hiddenScore.value = Math.round(this.state.score);
      this.elements.hiddenOrders.value = this.state.ordersCompleted;
      this.elements.hiddenCombo.value = this.state.maxCombo;
      this.elements.hiddenQte.value = `${this.state.qteSuccess}/${this.state.qteTotal} (${qteRate}%)`;
      this.elements.hiddenMessage.value = `Tire Rush 5% coupon request. Character: ${this.selectedCharacter.name}. Score: ${Math.round(this.state.score)}. Orders: ${this.state.ordersCompleted}. Max combo: ${this.state.maxCombo}. QTE: ${this.elements.hiddenQte.value}.`;
    }

    backToSelection() {
      if (this.frameId) cancelAnimationFrame(this.frameId);
      this.frameId = null;
      if (this.state) this.state.playing = false;
      this.hideTutorial();
      this.elements.gameArea.hidden = true;
      this.elements.result.hidden = true;
      this.section.querySelectorAll('[data-rush-character-card]').forEach((item) => item.classList.remove('is-selected'));
      this.elements.selection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    updateHud() {
      if (!this.state) return;
      this.elements.timer.textContent = `${Math.ceil(this.state.timeRemaining)}s`;
      this.elements.score.textContent = Math.round(this.state.score).toLocaleString();
      this.elements.combo.textContent = `x${this.comboMultiplier().toFixed(1)}`;
      this.elements.ordersDone.textContent = String(this.state.ordersCompleted);
      const primary = this.getPrimaryOrder();
      const ordered = primary
        ? [primary, ...this.state.orders.filter((order) => order.id !== primary.id)]
        : this.state.orders;
      this.elements.orders.innerHTML = ordered.map((order) => this.drawOrderGlyphChain(order, primary)).join('');
      this.applySpriteBackgrounds(this.elements.orders);
      this.elements.carried.innerHTML = this.state.carried.length
        ? this.state.carried.map((id) => {
          const tire = this.getTireType(id);
          return `<span class="rush-carried-glyph" style="--tire-color:${tire.color}" data-sprite-key="${tire.badgeKey}" aria-label="${escapeHtml(tire.label)} tire"></span>`;
        }).join('')
        : '<em class="rush-empty-cart" data-sprite-key="guide.cart" aria-label="Empty cart"></em>';
      this.applySpriteBackgrounds(this.elements.carried);
      const cd = this.state.skillCooldownRemaining;
      this.elements.skill.disabled = cd > 0 || this.state.pausedForUpgrade;
      this.elements.skillCooldown.textContent = cd > 0 ? `${Math.ceil(cd)}s` : 'Ready';
      this.elements.skill.style.setProperty('--cooldown', `${clamp(cd / Math.max(1, this.selectedCharacter.cooldown), 0, 1) * 100}%`);
    }

    drawOrderGlyphChain(order, primary) {
      const visual = this.getPrimaryOrderVisualState(order);
      return renderCompactOrderCue(order, visual, order.id === (primary && primary.id));
    }

    comboMultiplier() {
      return Math.min(2.5, 1 + Math.floor(this.state.combo / 3) * 0.25);
    }

    render(dt) {
      const ctx = this.ctx;
      const shake = this.state && this.state.screenShake ? this.state.screenShake : 0;
      if (this.state && this.state.screenShake) {
        this.state.screenShake = Math.max(0, this.state.screenShake - dt * 25);
      }
      ctx.save();
      ctx.clearRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
      if (shake > 0) {
        ctx.translate((Math.random() - 0.5) * shake, (Math.random() - 0.5) * shake);
      }
      this.drawWarehouse(ctx);
      if (this.state) {
        this.drawRoutes(ctx);
        this.drawBays(ctx);
        this.drawObstacles(ctx);
        this.drawTires(ctx);
        this.drawPlayer(ctx);
        this.drawParticles(ctx);
        this.drawFloaters(ctx);
        if (this.state.qteActive) this.drawQteWorldCue(ctx);
      }
      ctx.restore();
    }

    canDrawAtlas() {
      return this.spriteLoaded && this.sprite && this.sprite.complete;
    }

    drawSprite(key, x, y, options = {}) {
      if (!this.canDrawAtlas()) return false;
      const frame = ATLAS_V3.frames[key];
      if (!frame) return false;
      const width = options.width || frame.w * (options.scale || 1);
      const height = options.height || frame.h * (options.scale || 1);
      const anchor = options.anchor || 'center';
      let dx = -width / 2;
      let dy = -height / 2;
      if (anchor === 'top-left') {
        dx = 0;
        dy = 0;
      } else if (anchor === 'left-center') {
        dx = 0;
        dy = -height / 2;
      }
      this.ctx.save();
      this.ctx.globalAlpha = options.alpha == null ? 1 : options.alpha;
      this.ctx.translate(x, y);
      if (options.rotation) this.ctx.rotate(options.rotation);
      if (options.flipX) this.ctx.scale(-1, 1);
      this.ctx.drawImage(this.sprite, frame.x, frame.y, frame.w, frame.h, dx, dy, width, height);
      this.ctx.restore();
      return true;
    }

    drawSpriteLine(key, x1, y1, x2, y2, options = {}) {
      const angle = Math.atan2(y2 - y1, x2 - x1);
      const length = distance({ x: x1, y: y1 }, { x: x2, y: y2 });
      return this.drawSprite(key, x1, y1, {
        ...options,
        width: length,
        rotation: angle,
        anchor: 'left-center'
      });
    }

    tireFrameKey(tireId, rotation) {
      const frame = Math.abs(Math.floor((rotation / TWO_PI) * 4)) % 4;
      return `tire.${tireId}.${frame}`;
    }

    playerDirectionKey() {
      const angle = this.state.player.direction;
      if (angle > Math.PI * 0.25 && angle < Math.PI * 0.75) return 'south';
      if (angle < -Math.PI * 0.25 && angle > -Math.PI * 0.75) return 'north';
      if (Math.abs(angle) >= Math.PI * 0.75) return 'west';
      return 'east';
    }

    drawIdle() {
      this.drawWarehouse(this.ctx);
      this.ctx.fillStyle = '#123';
      this.ctx.font = '700 26px sans-serif';
      this.ctx.textAlign = 'center';
      this.ctx.fillText('Select a teammate to start Tire Rush', LOGICAL_WIDTH / 2, LOGICAL_HEIGHT / 2);
    }

    drawWarehouse(ctx) {
      if (this.canDrawAtlas()) {
        this.drawSprite('warehouseBase', 0, 0, {
          width: LOGICAL_WIDTH,
          height: LOGICAL_HEIGHT,
          anchor: 'top-left'
        });
        return;
      }

      const gradient = ctx.createLinearGradient(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
      gradient.addColorStop(0, '#eef5f8');
      gradient.addColorStop(1, '#d9e4e8');
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);

      if (this.spriteLoaded) {
        ctx.save();
        ctx.globalAlpha = 0.035;
        ctx.drawImage(this.sprite, 0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
        ctx.restore();
      }

      ctx.strokeStyle = 'rgba(19, 41, 61, 0.08)';
      ctx.lineWidth = 1;
      for (let x = 0; x < LOGICAL_WIDTH; x += 48) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, LOGICAL_HEIGHT);
        ctx.stroke();
      }
      for (let y = 0; y < LOGICAL_HEIGHT; y += 48) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(LOGICAL_WIDTH, y);
        ctx.stroke();
      }

      ctx.fillStyle = 'rgba(18, 55, 78, 0.16)';
      this.roundRect(ctx, 210, 70, 150, 42, 8, true);
      this.roundRect(ctx, 600, 72, 150, 42, 8, true);
      this.roundRect(ctx, 210, 486, 150, 42, 8, true);
      this.roundRect(ctx, 600, 486, 150, 42, 8, true);

      ctx.strokeStyle = 'rgba(245, 165, 36, 0.7)';
      ctx.lineWidth = 5;
      ctx.setLineDash([24, 18]);
      ctx.beginPath();
      ctx.moveTo(90, 300);
      ctx.bezierCurveTo(260, 205, 700, 395, 870, 300);
      ctx.stroke();
      ctx.setLineDash([]);
    }

    drawRoutes(ctx) {
      if (!this.state.orders.length) return;
      const primary = this.getPrimaryOrder();
      if (!primary) return;
      const step = this.getPlayerStepForOrder(primary);
      const routeTarget = step === 'drop' ? primary.bay : this.findNearestTireForOrder(primary);
      if (!routeTarget) return;
      if (this.canDrawAtlas()) {
        const alpha = this.effects.routeScanner || this.hasEffect('route-scanner') ? 0.95 : 0.75;
        this.drawSpriteLine('routeGlow', this.state.player.x, this.state.player.y, routeTarget.x, routeTarget.y, {
          height: step === 'drop' ? 52 : 40,
          alpha: alpha * 0.82
        });
        this.drawSpriteLine(this.effects.routeScanner || this.hasEffect('route-scanner') ? 'scanLine' : 'routeDash', this.state.player.x, this.state.player.y, routeTarget.x, routeTarget.y, {
          height: step === 'drop' ? 26 : 20,
          alpha
        });
        return;
      }
      ctx.save();
      ctx.strokeStyle = this.hexToRgba(primary.tireColor, this.effects.routeScanner || this.hasEffect('route-scanner') ? 0.75 : 0.52);
      ctx.lineWidth = step === 'drop' ? 6 : 4;
      ctx.setLineDash([10, 12]);
      ctx.beginPath();
      ctx.moveTo(this.state.player.x, this.state.player.y);
      ctx.lineTo(routeTarget.x, routeTarget.y);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.restore();
    }

    drawBays(ctx) {
      const primary = this.getPrimaryOrder();
      const visual = this.getPrimaryOrderVisualState(primary);
      const step = visual ? visual.step : 'pick';
      ORDER_BAYS.forEach((bay) => {
        const active = primary && step === 'drop' && primary.bayId === bay.id;
        const warning = this.state.wrongDropBayId === bay.id && this.state.wrongDropWarningUntil > this.state.elapsed;
        if (this.canDrawAtlas()) {
          const frameState = active ? 'active' : 'base';
          this.drawSprite('shadow', bay.x, bay.y + 30, { width: 104, height: 34, alpha: 0.4 });
          this.drawSprite(`bay.${bay.id}.${frameState}`, bay.x, bay.y, {
            width: active ? bay.dropRadius * 2.18 : 96,
            height: active ? 86 : 70,
            alpha: active ? 1 : 0.54
          });
          if (active) {
            this.drawTargetGhost(bay, visual);
          }
          if (warning) {
            this.drawSprite('guide.noEntry', bay.x, bay.y - 62, { width: 56, height: 56, alpha: 0.95 });
          }
          return;
        }
        ctx.save();
        ctx.translate(bay.x, bay.y);
        ctx.fillStyle = active ? this.hexToRgba(bay.color, 0.25 + Math.sin(performance.now() / 180) * 0.08) : 'rgba(255,255,255,0.45)';
        ctx.strokeStyle = active ? bay.color : 'rgba(18, 41, 61, 0.25)';
        ctx.lineWidth = 4;
        this.roundRect(ctx, -45, -32, 90, 64, 10, true, true);
        if (active) {
          ctx.strokeStyle = this.hexToRgba(primary.tireColor, 0.75);
          ctx.beginPath();
          ctx.arc(0, 0, bay.dropRadius, 0, TWO_PI);
          ctx.stroke();
          this.drawTireIcon(ctx, 0, -6, 20, primary.tireColor, visual.tireType.accent, '');
        }
        if (warning) {
          ctx.strokeStyle = '#ff6262';
          ctx.lineWidth = 6;
          ctx.beginPath();
          ctx.arc(0, -48, 18, 0, TWO_PI);
          ctx.moveTo(-12, -60);
          ctx.lineTo(12, -36);
          ctx.stroke();
        }
        ctx.restore();
      });
    }

    drawTargetGhost(bay, visual) {
      const pulse = 1 + Math.sin(performance.now() / 140) * 0.06;
      this.drawSprite('guide.targetHalo', bay.x, bay.y - 6, {
        width: bay.dropRadius * 2.65 * pulse,
        height: bay.dropRadius * 1.72 * pulse,
        alpha: 0.82
      });
      this.drawSprite('guide.dropGhost', bay.x, bay.y - 25, {
        width: 78,
        height: 78,
        alpha: 0.78
      });
      this.drawSprite(visual.tireFrameKey, bay.x, bay.y - 24, {
        width: 46,
        height: 46,
        alpha: 0.98
      });
      this.drawSprite(visual.badgeKey, bay.x, bay.y - 82, {
        width: 44,
        height: 44,
        alpha: 0.98
      });
      this.drawSprite('guide.chevron', bay.x, bay.y - 105, {
        width: 52,
        height: 52,
        rotation: Math.PI / 2,
        alpha: 0.92
      });
    }

    drawObstacles(ctx) {
      this.state.obstacles.forEach((obstacle) => {
        if (this.canDrawAtlas()) {
          this.drawSprite('shadow', obstacle.x, obstacle.y + obstacle.radius * 0.55, {
            width: obstacle.radius * 2.2,
            height: obstacle.radius * 0.75,
            alpha: 0.32
          });
          const obstacleKey = hasAtlasFrame(`obstacle.${obstacle.type}`) ? `obstacle.${obstacle.type}` : 'obstacle.box';
          this.drawSprite(obstacleKey, obstacle.x, obstacle.y, {
            width: obstacle.radius * 2.15,
            height: obstacle.radius * 2.15,
            rotation: Math.sin(obstacle.pulse) * 0.04
          });
          return;
        }
        ctx.save();
        ctx.translate(obstacle.x, obstacle.y);
        ctx.rotate(Math.sin(obstacle.pulse) * 0.04);
        if (obstacle.type === 'oil') {
          ctx.fillStyle = 'rgba(36, 44, 59, 0.36)';
          ctx.beginPath();
          ctx.ellipse(0, 0, obstacle.radius * 1.25, obstacle.radius * 0.62, 0.2, 0, TWO_PI);
          ctx.fill();
          ctx.fillStyle = 'rgba(127, 200, 255, 0.22)';
          ctx.beginPath();
          ctx.ellipse(-8, -5, obstacle.radius * 0.45, obstacle.radius * 0.18, -0.1, 0, TWO_PI);
          ctx.fill();
        } else if (obstacle.type === 'forklift') {
          ctx.fillStyle = '#f5a524';
          this.roundRect(ctx, -38, -22, 76, 44, 7, true);
          ctx.fillStyle = '#17324d';
          ctx.fillRect(-56, -17, 24, 6);
          ctx.fillRect(-56, 12, 24, 6);
          ctx.fillStyle = '#263238';
          ctx.beginPath();
          ctx.arc(-22, 26, 8, 0, TWO_PI);
          ctx.arc(26, 26, 8, 0, TWO_PI);
          ctx.fill();
        } else if (obstacle.type === 'tire-wall') {
          for (let i = 0; i < 5; i += 1) {
            this.drawTireIcon(ctx, -38 + i * 19, Math.sin(i) * 5, 13, '#343a40', '#f8f9fa', '');
          }
        } else if (obstacle.type === 'pallet') {
          ctx.fillStyle = '#b08968';
          for (let i = 0; i < 4; i += 1) {
            this.roundRect(ctx, -38, -20 + i * 13, 76, 8, 2, true);
          }
        } else {
          ctx.fillStyle = '#ff7b00';
          ctx.beginPath();
          ctx.moveTo(0, -26);
          ctx.lineTo(24, 24);
          ctx.lineTo(-24, 24);
          ctx.closePath();
          ctx.fill();
          ctx.fillStyle = '#fff';
          ctx.fillRect(-10, 2, 20, 5);
        }
        ctx.restore();
      });
    }

    drawTires(ctx) {
      const primary = this.getPrimaryOrder();
      const visual = this.getPrimaryOrderVisualState(primary);
      const step = visual ? visual.step : 'pick';
      this.state.tires.forEach((tire) => {
        const needed = primary && step === 'pick' && primary.tireId === tire.tireId;
        const glow = needed || (this.hasEffect('perfect-match') && this.state.orders.some((order) => order.tireId === tire.tireId));
        if (this.canDrawAtlas()) {
          if (glow) {
            this.drawSprite('routeGlow', tire.x, tire.y, {
              width: needed ? 78 + Math.sin(performance.now() / 120) * 8 : 62,
              height: needed ? 54 : 42,
              alpha: needed ? 0.86 : 0.48
            });
            if (needed) {
              this.drawSprite(tire.badgeKey, tire.x, tire.y - 42, {
                width: 38,
                height: 38,
                alpha: 0.98
              });
            }
          }
          this.drawSprite('shadow', tire.x, tire.y + 16, { width: glow ? 44 : 36, height: glow ? 18 : 14, alpha: glow ? 0.28 : 0.16 });
          this.drawSprite(this.tireFrameKey(tire.tireId, tire.spin), tire.x, tire.y, {
            width: tire.radius * (glow ? 3.2 : 2.75),
            height: tire.radius * (glow ? 3.2 : 2.75),
            alpha: glow ? 1 : 0.62
          });
          return;
        }
        if (glow) {
          ctx.fillStyle = this.hexToRgba(tire.color, 0.28);
          ctx.beginPath();
          ctx.arc(tire.x, tire.y, 30 + Math.sin(performance.now() / 120) * 3, 0, TWO_PI);
          ctx.fill();
        }
        ctx.save();
        ctx.globalAlpha = glow ? 1 : 0.62;
        ctx.translate(tire.x, tire.y);
        ctx.rotate(tire.spin);
        this.drawTireIcon(ctx, 0, 0, tire.radius, tire.color, tire.accent, tire.short);
        ctx.restore();
      });
    }

    drawPlayer(ctx) {
      const player = this.state.player;
      if (this.canDrawAtlas()) {
        const direction = this.playerDirectionKey();
        const frame = Math.abs(Math.floor(player.step * 3)) % 3;
        if (this.hasEffect('nitro') || this.hasEffect('sprint')) {
          this.drawSprite('particle.speedLine', player.x - Math.cos(player.direction) * 32, player.y - Math.sin(player.direction) * 32, {
            width: 86,
            height: 36,
            rotation: player.direction,
            alpha: 0.72
          });
        }
        this.drawSprite('shadow', player.x, player.y + 22, { width: 72, height: 28, alpha: 0.35 });
        this.drawSprite(`player.${direction}.${frame}`, player.x, player.y, {
          width: direction === 'north' || direction === 'south' ? 52 : 72,
          height: 76
        });
        this.state.carried.forEach((id, index) => {
          const offsetX = -38 - index * 6;
          const offsetY = -18 + index * 13;
          this.drawSprite(this.tireFrameKey(id, index), player.x + offsetX, player.y + offsetY, {
            width: 22,
            height: 22
          });
        });
        return;
      }
      ctx.save();
      ctx.translate(player.x, player.y);
      const bounce = Math.sin(player.step * TWO_PI) * 2;
      ctx.rotate(player.direction);
      if (this.hasEffect('nitro') || this.hasEffect('sprint')) {
        ctx.fillStyle = 'rgba(79, 140, 255, 0.24)';
        ctx.beginPath();
        ctx.ellipse(-22, 0, 34, 16, 0, 0, TWO_PI);
        ctx.fill();
      }
      ctx.fillStyle = '#1f6feb';
      this.roundRect(ctx, -8, -13 + bounce, 23, 26, 7, true);
      ctx.fillStyle = '#0b172a';
      ctx.beginPath();
      ctx.arc(5, -18 + bounce, 9, 0, TWO_PI);
      ctx.fill();
      ctx.strokeStyle = '#13293d';
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(-10, -7 + bounce);
      ctx.lineTo(-24, -14 + bounce);
      ctx.moveTo(-10, 8 + bounce);
      ctx.lineTo(-24, 16 + bounce);
      ctx.stroke();
      ctx.fillStyle = '#e9f2ff';
      this.roundRect(ctx, -45, -21, 24, 42, 6, true);
      ctx.fillStyle = '#495057';
      ctx.beginPath();
      ctx.arc(-37, -16, 5, 0, TWO_PI);
      ctx.arc(-37, 16, 5, 0, TWO_PI);
      ctx.fill();
      this.state.carried.forEach((id, index) => {
        const tire = TIRE_TYPES.find((type) => type.id === id);
        this.drawTireIcon(ctx, -56 - index * 6, -11 + index * 11, 8, tire.color, tire.accent, '');
      });
      ctx.restore();
    }

    drawTireIcon(ctx, x, y, radius, color, accent, label) {
      ctx.save();
      ctx.translate(x, y);
      ctx.fillStyle = '#20252d';
      ctx.beginPath();
      ctx.arc(0, 0, radius, 0, TWO_PI);
      ctx.fill();
      ctx.strokeStyle = color;
      ctx.lineWidth = Math.max(3, radius * 0.22);
      ctx.beginPath();
      ctx.arc(0, 0, radius * 0.72, 0, TWO_PI);
      ctx.stroke();
      ctx.fillStyle = accent || '#f8f9fa';
      ctx.beginPath();
      ctx.arc(0, 0, radius * 0.34, 0, TWO_PI);
      ctx.fill();
      if (label) {
        ctx.fillStyle = '#111827';
        ctx.font = `800 ${Math.max(7, radius * 0.38)}px sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(label.slice(0, 3), 0, 0);
      }
      ctx.restore();
    }

    drawParticles(ctx) {
      this.state.particles.forEach((particle) => {
        const alpha = clamp(particle.life / particle.maxLife, 0, 1);
        if (this.canDrawAtlas()) {
          const key = particle.type === 'ring'
            ? 'particle.burst'
            : particle.type === 'burst'
              ? 'particle.burst'
              : particle.type === 'spark'
                ? 'particle.spark'
                : 'particle.star';
          this.drawSprite(key, particle.x, particle.y, {
            width: particle.radius * (particle.type === 'ring' ? 8 : 5),
            height: particle.radius * (particle.type === 'ring' ? 8 : 5),
            rotation: particle.rotation,
            alpha
          });
          return;
        }
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(particle.x, particle.y);
        ctx.rotate(particle.rotation);
        ctx.fillStyle = particle.color;
        if (particle.type === 'ring') {
          ctx.strokeStyle = particle.color;
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.arc(0, 0, particle.radius * 2.4, 0, TWO_PI);
          ctx.stroke();
        } else {
          ctx.beginPath();
          ctx.moveTo(0, -particle.radius);
          ctx.lineTo(particle.radius, 0);
          ctx.lineTo(0, particle.radius);
          ctx.lineTo(-particle.radius, 0);
          ctx.closePath();
          ctx.fill();
        }
        ctx.restore();
      });
    }

    drawFloaters(ctx) {
      this.state.floaters.forEach((floater) => {
        ctx.save();
        ctx.globalAlpha = clamp(floater.life, 0, 1);
        if (floater.iconKey && this.canDrawAtlas()) {
          ctx.restore();
          this.drawSprite(floater.iconKey, floater.x, floater.y, {
            width: 42,
            height: 42,
            alpha: clamp(floater.life, 0, 1)
          });
          return;
        } else if (floater.iconKey) {
          ctx.fillStyle = floater.color || '#ffd166';
          ctx.beginPath();
          ctx.arc(floater.x, floater.y, 16, 0, TWO_PI);
          ctx.fill();
          ctx.restore();
          return;
        }
        ctx.fillStyle = floater.color;
        ctx.font = '800 18px sans-serif';
        ctx.textAlign = 'center';
        ctx.strokeStyle = 'rgba(0,0,0,0.35)';
        ctx.lineWidth = 4;
        ctx.strokeText(floater.text, floater.x, floater.y);
        ctx.fillText(floater.text, floater.x, floater.y);
        ctx.restore();
      });
    }

    drawQteWorldCue(ctx) {
      const qte = this.state.qteActive;
      if (this.canDrawAtlas()) {
        this.drawSprite('warningFrame', LOGICAL_WIDTH / 2, LOGICAL_HEIGHT / 2, {
          width: LOGICAL_WIDTH - 30,
          height: LOGICAL_HEIGHT - 30,
          alpha: 0.9
        });
        this.drawSprite(qte.eventFrameKey, LOGICAL_WIDTH / 2, 86, {
          width: 86,
          height: 86,
          alpha: 0.94
        });
        this.drawSpriteLine('scanLine', 42, LOGICAL_HEIGHT - 46, LOGICAL_WIDTH - 42, LOGICAL_HEIGHT - 46, {
          height: 18,
          alpha: 0.55
        });
        return;
      }
      ctx.save();
      ctx.fillStyle = 'rgba(255, 98, 98, 0.13)';
      ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
      ctx.strokeStyle = '#ff6262';
      ctx.lineWidth = 6;
      ctx.setLineDash([20, 14]);
      ctx.strokeRect(16, 16, LOGICAL_WIDTH - 32, LOGICAL_HEIGHT - 32);
      ctx.setLineDash([]);
      ctx.fillStyle = 'rgba(255, 209, 102, 0.88)';
      ctx.beginPath();
      ctx.moveTo(LOGICAL_WIDTH / 2, 36);
      ctx.lineTo(LOGICAL_WIDTH / 2 + 26, 84);
      ctx.lineTo(LOGICAL_WIDTH / 2 - 26, 84);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    }

    roundRect(ctx, x, y, w, h, r, fill, stroke) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
      if (fill) ctx.fill();
      if (stroke) ctx.stroke();
    }

    hexToRgba(hex, alpha) {
      const normalized = hex.replace('#', '');
      const bigint = parseInt(normalized, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    isTouchDevice() {
      return window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    }
  }

  function initTireRush() {
    document.querySelectorAll('[data-tire-rush]').forEach((section) => {
      if (section.__tireRushGame) return;
      section.__tireRushGame = new TireRushGame(section);
    });
  }

  if (typeof document !== 'undefined' && document.addEventListener && document.querySelectorAll) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTireRush);
    } else {
      initTireRush();
    }
  }
}());
